<template>
    <div :class="{ 'disabled': disabled, 'simple-button': true }">
        <div class="simple-button-content-wrapper" @click="handleClick">
            <template v-if="loading">
                <icon :icon="['fal', 'spinner']" spin/>
            </template>
            <template v-else-if="!loading && error">
                Error
            </template>
            <template v-else>
                <slot/>
            </template>
        </div>
        <div class="simple-button-confirmation" v-if="displayConfirmation">
            {{$t('confirmPlease')}} {{protectionMessage}}
            <div class="confirmation-answers">
                <simple-button @press="() => handleProceed()">{{$t('confirm')}}</simple-button>
                <simple-button @press="() => handleCancel()">{{$t("cancel")}}</simple-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SimpleButton",
        props:{
            inline: Boolean,
            timeProtected: Boolean,
            protectionTime: {
                type: Number,
                default: 5
            },
            confirmationProtected: Boolean,
            protectionMessage: String,
            disabled: Boolean
        },
        data: function () {
            return {
                displayConfirmation: false,
                loading: false,
                error: false
            }
        },
        methods: {
            async handleClick() {
                if(this.disabled) return;
                if(this.confirmationProtected) {
                    this.displayConfirmation = !this.displayConfirmation;
                    return;
                }
                this.loading = true;
                try {
                    await this.$listeners.press();
                }
                catch(err) {
                    this.error = true;
                }
                finally {
                    this.loading = false;
                }


            },
            handleProceed() {
                this.displayConfirmation = false;
                this.$emit("proceed");
            },
            handleCancel() {
                this.displayConfirmation = false;
                this.$emit("cancel");
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";

    .simple-button {
        display: flex;
        position: relative;
        cursor: pointer;
        //background-color: var(--button-background-color);
        box-shadow:inset 0px 1px 0px 0px var(--accent-colo-plus-25);
        background:linear-gradient(to bottom, var(--accent-color) 5%, #C85858 100%);
        border-radius: 2px;
        color: var(--button-font-color);
        justify-content: center;
    }

    .simple-button:hover {
        background:linear-gradient(to bottom, var(--accent-color) 75%, #C85858 100%);
    }

    .simple-button-confirmation {
        display: flex;
        flex-flow: column;
        padding: 5px;
        justify-content: center;
        align-content: center;
        align-items: center;
        justify-items: center;

        border-radius: 2px;
        top: calc(100% + 5px);
        left: 0;
        min-width: 300px;
        width: 100%;
        position: absolute;
        background-color: var(--input-list-background-color);
        z-index: 100;
        cursor: default;
    }

    .confirmation-answers {
        display: flex;
        flex-flow: row;
        width: 100%;
        justify-content: space-around;
    }

    .confirmation-answers>* {
        width: 100%;
        margin: 5px;
    }

    .simple-button-content-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
        padding: 3px 5px 3px 5px;
        cursor: inherit;
        justify-content: center;
        align-content: center;
        justify-items: center;
        align-items: center;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        text-align: center;
    }

    .disabled {
        box-shadow: none;
        background-image: repeating-linear-gradient(45deg, lighten($navigationGray, 5), lighten($navigationGray, 5) 15px, lighten($navigationGray, 10) 15px, lighten($navigationGray, 10) 30px);
        cursor: no-drop;
        color: grey;
    }

    .disabled:hover {
        box-shadow: none;
        background-image: repeating-linear-gradient(45deg, lighten($navigationGray, 5), lighten($navigationGray, 5) 15px, lighten($navigationGray, 10) 15px, lighten($navigationGray, 10) 30px);
    }
</style>
